<template>
	<div class="row">
		<rotina-list-toolbar modal-id="filtrosAvancadosRelatoriosConvenio" :active-filters="quantidadeFiltrosAtivos" :can-create="false" @search="carregarRelatorios(0)" @apply="carregarRelatorios(0)" @clear="limparFiltrosAvancados">
			<template v-slot:actions><button type="button" class="btn btn-outline-primary" @click="carregarRelatorios(0)"><i class="far fa-sync me-1"></i>Atualizar</button></template>
			<template v-slot:quick><label><i class="far fa-search color-theme me-1"></i>Afiliado / observação</label><input v-model.trim="pesquisa.termo" class="form-control" placeholder="Busque nos pagamentos" @keyup.enter="carregarRelatorios(0)" /></template>
			<template v-slot:advanced><div class="col-md-3"><label>Pagamento de</label><input v-model="pesquisa.dataDe" type="date" class="form-control" /></div><div class="col-md-3"><label>Pagamento até</label><input v-model="pesquisa.dataAte" type="date" class="form-control" /></div><div class="col-md-3"><label>Valor mínimo</label><input v-model.number="pesquisa.valorMin" type="number" min="0" step="0.01" class="form-control" /></div><div class="col-md-3"><label>Valor máximo</label><input v-model.number="pesquisa.valorMax" type="number" min="0" step="0.01" class="form-control" /></div></template>
		</rotina-list-toolbar>
		<div v-if="false" id="search-nav" class="col-12 d-block btn-group dropup">
         <button type="button" class="btn btn-primary dropdown-toggle d-block d-lg-none" data-bs-toggle="dropdown" data-bs-auto-close="false" aria-expanded="false">
            <i class="far fa-search font-17 mx-auto"></i><i class="fal fa-times font-17 mx-auto"></i>
         </button>
         <div class="card mb-2 dropdown-menu dropdown-menu-left">
            <div class="card-body pb-0">
               <div class="row">
						<div class="col-sm mb-3">
							<div class="d-flex justify-content-between align-items-center h-100">
								<h5 class="mb-0">Relatórios de Pagamento (Convênio)</h5>
								<button type="button" class="btn btn-primary" @click="carregarRelatorios(0)">
									<i class="far fa-sync font-13"></i> Atualizar
								</button>
							</div>
						</div>
               </div>
            </div>
         </div>
      </div>

		<cadastro-grid
			:rows="pesquisa.resultados"
			:columns="gridColumns"
			:actions="gridActions"
			title="Pagamentos Registrados"
			empty-text="Nenhum relatório encontrado."
			:total="pesquisa.total"
			:page="pesquisa.pagina"
			:size="pesquisa.tamanho"
			:showing-text="textoExibindo"
			@page-change="carregarRelatorios"
			@size-change="pesquisa.tamanho = $event; pesquisa.pagina = 0; carregarRelatorios(0)"
			@action="tratarAcaoGrid"
		>
			<template v-slot:cell-dataPagamento="{ row }">
				{{ formatarData(row.dataPagamento) }}
			</template>
			<template v-slot:cell-valorPago="{ row }">
				<span class="text-success fw-bold">{{ formatarMoeda(row.valorPago) }}</span>
			</template>
			<template v-slot:cell-valorAnterior="{ row }">
				<span class="text-danger">{{ formatarMoeda(row.valorAnterior) }}</span>
			</template>
			<template v-slot:cell-valorAtualizado="{ row }">
				<span class="text-danger">{{ formatarMoeda(row.valorAtualizado) }}</span>
			</template>
		</cadastro-grid>

		<!-- Modal Visualizar -->
		<div class="modal fade" id="modalVisualizar" tabindex="-1" aria-labelledby="modalVisualizarLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header bg-theme text-white">
						<h5 class="modal-title" id="modalVisualizarLabel">Detalhes do Pagamento #{{ relatorioSelecionado?.id }}</h5>
						<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<ul class="list-group list-group-flush" v-if="relatorioSelecionado">
							<li class="list-group-item d-flex justify-content-between align-items-center">
								Afiliado
								<span class="fw-bold">{{ relatorioSelecionado.pessoaNome }}</span>
							</li>
							<li class="list-group-item d-flex justify-content-between align-items-center">
								Data do Pagamento
								<span>{{ formatarData(relatorioSelecionado.dataPagamento) }}</span>
							</li>
							<li class="list-group-item d-flex justify-content-between align-items-center">
								Dívida Anterior
								<span class="text-danger">{{ formatarMoeda(relatorioSelecionado.valorAnterior) }}</span>
							</li>
							<li class="list-group-item d-flex justify-content-between align-items-center">
								Valor Pago (Abatido)
								<span class="text-success fw-bold">{{ formatarMoeda(relatorioSelecionado.valorPago) }}</span>
							</li>
							<li class="list-group-item d-flex justify-content-between align-items-center">
								Dívida Restante
								<span class="text-danger fw-bold">{{ formatarMoeda(relatorioSelecionado.valorAtualizado) }}</span>
							</li>
							<li class="list-group-item">
								<div class="fw-bold mb-1">Observação</div>
								<div class="text-muted font-12">{{ relatorioSelecionado.observacao || 'Nenhuma observação informada.' }}</div>
							</li>
						</ul>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import $ from 'jquery'
import { mapState } from 'vuex'
import cadastroGrid from '@/components/cadastros/CadastroGrid.vue'

export default {
	name: 'RelatoriosConvenio',
	components: { cadastroGrid },
	data() {
		return {
			pesquisa: { termo: '', dataDe: '', dataAte: '', valorMin: null, valorMax: null, resultados: [], pagina: 0, tamanho: 20, total: 0 },
			relatorioSelecionado: null
		}
	},
	computed: {
		quantidadeFiltrosAtivos() { return [this.pesquisa.dataDe, this.pesquisa.dataAte, this.pesquisa.valorMin, this.pesquisa.valorMax].filter(value => value !== '' && value !== null && value !== undefined).length },
		...mapState({ urlRest: state => state.urlRest, empresa: state => state.empresa }),
		textoExibindo() {
			const total = this.pesquisa.total
			const page = this.pesquisa.pagina
			const size = this.pesquisa.tamanho
			if (total === 0) return '0'
			return `${page * size + 1}-${Math.min((page + 1) * size, total)}`
		},
		gridColumns() {
			return [
				{ key: 'id', label: 'ID', width: '80px' },
				{ key: 'pessoaNome', label: 'Afiliado' },
				{ key: 'dataPagamento', label: 'Data', width: '180px' },
				{ key: 'valorAnterior', label: 'Dívida Anterior', width: '150px' },
				{ key: 'valorPago', label: 'Valor Pago', width: '150px' },
				{ key: 'valorAtualizado', label: 'Dívida Atualizada', width: '150px' }
			]
		},
		gridActions() {
			return [
				{ icon: 'far fa-eye', name: 'visualizar', tooltip: 'Detalhes', color: 'text-primary' }
			]
		}
	},
	mounted() {
		this.carregarRelatorios(0)
	},
	methods: {
		limparFiltrosAvancados() { Object.assign(this.pesquisa, { dataDe: '', dataAte: '', valorMin: null, valorMax: null }); this.carregarRelatorios(0) },
		formatarMoeda(valor) {
			if (valor == null) return 'R$ 0,00';
			return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
		},
		formatarData(dataStr) {
			if (!dataStr) return '-';
			const date = new Date(dataStr);
			return date.toLocaleString('pt-BR');
		},
		carregarRelatorios(pagina) {
			this.pesquisa.pagina = pagina == null ? this.pesquisa.pagina + 1 : pagina
			this.$store.dispatch('alternarTelaCarregamento', 1)

			this.$axios.get(this.urlRest + 'convenio/relatorios', {
				headers: { 'X-Company-Id': this.empresa.id },
				params: { page: this.pesquisa.pagina, size: this.pesquisa.tamanho, termo: this.pesquisa.termo || undefined, dataDe: this.pesquisa.dataDe || undefined, dataAte: this.pesquisa.dataAte || undefined, valorMin: this.pesquisa.valorMin ?? undefined, valorMax: this.pesquisa.valorMax ?? undefined }
			}).then(res => {
				const data = res.data
				this.pesquisa.resultados = data.content || []
				this.pesquisa.total = data.totalElements || data.total || this.pesquisa.resultados.length
			}).catch(() => {
				this.$toast.fire({ icon: 'error', title: 'Erro ao carregar relatórios.' })
			}).finally(() => this.$store.dispatch('alternarTelaCarregamento', -1))
		},
		tratarAcaoGrid(acao, row) {
			if (acao === 'visualizar') {
				this.relatorioSelecionado = row
				$('#modalVisualizar').modal('show')
			}
		}
	}
}
</script>
